"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DeleteModal", {
  enumerable: true,
  get: function get() {
    return _DeleteModal.DeleteModal;
  }
});
var _DeleteModal = require("./DeleteModal");